module.exports = __webpack_public_path__ + "img/qr-code-generate.fb6bf46e.svg";